import instance from "./instance";

const checkLayout = (settings, selectedFilters) => {
  return (
    selectedFilters?.length > 0 ||
    settings.store_layout === "grid" ||
    settings.store_layout === "grid2" ||
    settings.store_layout === "scroll"
  );
};

export const setFilter = (filterName, filterOptionName, value, type = "") => {
  return async (dispatch) => {
    dispatch({
      type: "SET_PRODUCT_FILTER",
      payload: {
        filterName: filterName,
        filterOptionName: filterOptionName,
        value: value,
        type: type,
      },
    });
  };
};
export const applyFilters = (
  filtersToApply,
  sortOption,
  priceRangeToApply,
  selectedCategories,
  availableProducts,
  nutritionalFact
) => {
  return async (dispatch) => {
    dispatch({
      type: "APPLY_PRODUCT_FILTER",
      payload: {
        filtersToApply: filtersToApply,
        sortOption: sortOption,
        priceRangeToApply: priceRangeToApply,
        selectedCategories: selectedCategories,
        availableProducts: availableProducts,
        nutritionalFact: nutritionalFact,
      },
    });
  };
};
export const clearFilters = () => {
  return async (dispatch) => {
    dispatch({
      type: "CLEAR_PRODUCT_FILTER",
    });
  };
};

export const deleteFilter = (value, count) => {
  return async (dispatch, getState) => {
    dispatch({
      type: "DELETE_PRODUCT_FILTER",
      payload: {
        value: value,
      },
    });
    const settings = getState().store.store.settings;
    const selectedFilters = getState().productFilter?.filtersSelected;
    if (checkLayout(settings, selectedFilters) && count !== 1) {
      await fetchFilteredCategories(dispatch, getState());
    }
  };
};

export const clearSortBy = () => {
  return async (dispatch) => {
    dispatch({
      type: "CLEAR_SORT_BY",
    });
  };
};

export const clearPriceRange = (count) => {
  return async (dispatch, getState) => {
    dispatch({
      type: "CLEAR_PRICE_RANGE",
    });
    const settings = getState().store.store.settings;
    const selectedFilters = getState().productFilter?.filtersSelected;

    if (checkLayout(settings, selectedFilters) && count !== 1) {
      await fetchFilteredCategories(dispatch, getState());
    }
  };
};

export const deleteCategory = (value, count) => {
  return async (dispatch, getState) => {
    dispatch({
      type: "DELETE_CATEGORY",
      payload: {
        value: value,
      },
    });
    const settings = getState().store.store.settings;
    const selectedFilters = getState().productFilter?.filtersSelected;

    if (checkLayout(settings, selectedFilters) && count !== 1) {
      await fetchFilteredCategories(dispatch, getState());
    }
  };
};
export const deleteAvailableProduct = (count) => {
  return async (dispatch, getState) => {
    dispatch({
      type: "DELETE_AVAILABLE_PRODUCT",
    });
    const settings = getState().store.store.settings;
    const selectedFilters = getState().productFilter?.filtersSelected;

    if (checkLayout(settings, selectedFilters) && count !== 1) {
      await fetchFilteredCategories(dispatch, getState());
    }
  };
};

export const setFetchCategory = (value) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_FETCH_CATEGORY",
      payload: value,
    });
  };
};

export const setLoading = (value) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_LOADING",
      payload: value,
    });
  };
};

const fetchFilteredCategories = async (dispatch, state) => {
  try {
    dispatch(setLoading(true));
    const settings = state.store.store.settings;
    const branch = state.branch;
    const checkIfBranchBased =
      settings.is_branch_based_ordering && (branch.branch || branch.bdc);

    const priceRangeToApply = state.productFilter.priceRange.range;
    const channel = state.promise.src;

    const nutritionalFactFilter = state.productFilter.nutritionalFact;
    const checkIfNutritionalFactIsUsed = () => {
      return (
        nutritionalFactFilter.calories === null &&
        nutritionalFactFilter.carbs === null &&
        nutritionalFactFilter.protein === null &&
        nutritionalFactFilter.fats === null &&
        nutritionalFactFilter.dietaryRestrictions.length === 0
      );
    };
    const res = checkIfBranchBased
      ? await instance.post("/filter_products/", {
          categories: state.productFilter.selectedCategories,
          filter_options: state.productFilter.filtersSelected.map(
            (filter) => filter.value
          ),
          priceRange: priceRangeToApply,
          sortBy: state.productFilter.sortBy.value,
          type: branch.isPickup ? "pickup" : "delivery",
          branch_id: branch.branch,
          bdc_id: !branch.isPickup ? branch.bdc : branch.branch,
          channel: channel,
          nutritionalFact: checkIfNutritionalFactIsUsed()
            ? null
            : state.productFilter.nutritionalFact,
        })
      : await instance.post("/filter_products/", {
          categories: state.productFilter.selectedCategories,
          filter_options: state.productFilter.filtersSelected.map(
            (filter) => filter.value
          ),
          priceRange: priceRangeToApply,
          sortBy: state.productFilter.sortBy.value,
          channel: channel,
          nutritionalFact: checkIfNutritionalFactIsUsed()
            ? null
            : state.productFilter.nutritionalFact,
        });

    if (res.data.success === true) {
      dispatch({
        type: "SET_FETCH_CATEGORY",
        payload: res.data.categories,
      });
      dispatch(setLoading(false));
    }
  } catch (err) {
    // A failed request must never leave the results in a loading state.
  } finally {
    dispatch(setLoading(false));
  }
};

export const resetFilter = () => {
  return async (dispatch) => {
    dispatch({
      type: "RESET_FILTER",
    });
  };
};

export const clearNutritionalFact = (count) => {
  return async (dispatch, getState) => {
    dispatch({
      type: "CLEAR_NUTRITIONAL_FACT",
    });
    const settings = getState().store.store.settings;
    if (checkLayout(settings) && count !== 1) {
      await fetchFilteredCategories(dispatch, getState());
    }
  };
};

export const setFetchFiltersLoading = (value) => {
  return async (dispatch) => {
    dispatch({
      type: "SET_FETCH_FILTERS_LOADING",
      payload: value,
    });
  };
};

export const fetchFilters = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const scope = JSON.stringify([state.store.store.id, state.branch.branch]);
    if (state.productFilter.fetchLoading) return;
    if (state.productFilter.metadataScope === scope &&
        Date.now() - state.productFilter.metadataFetchedAt < 60000) return;
    try {
      const branch = getState().branch;
      dispatch(setFetchFiltersLoading(true));

      const res = await instance.post("/fetch_filters/", {
        branch_id: branch.branch,
      });

      if (res.data.success === true) {
        dispatch({
          type: "FETCH_FILTERS",
          payload: {
            data: res.data.data,
            layout: getState().store.store.settings.store_layout,
            sortByFilter: getState().store.store.settings.enable_sort_by_filter,
            priceFilter: getState().store.store.settings.enable_price_filter,
            availableProducts:
              getState().store.store.settings.enable_available_products_filter,
          },
        });
        dispatch(setFetchFiltersLoading(false));
        dispatch({ type: "FILTER_METADATA_FETCHED", payload: { scope, time: Date.now() } });
      }
    } catch (err) {
      // Allow another attempt after transient failures.
    } finally {
      dispatch(setFetchFiltersLoading(false));
    }
  };
};
